import { Component, OnInit } from '@angular/core';
import { ReportConstants } from '../../models/report-parameters.model';

@Component({
  selector: 'lib-rt-outbound-by-customer-report',
  templateUrl: './rt-outbound-by-customer-report.component.html',
  styleUrls: ['./rt-outbound-by-customer-report.component.css']
})
export class RtOutboundByCustomerReportComponent implements OnInit {

    public gridId = 118;
    public apiCall: string = ReportConstants.ReportDataApiCall;
    public pageHeader: string = 'Outbound At Customer By Customer Report';

  constructor() { }

  ngOnInit(): void {
  }

}
